import { createMetricsFactory } from 'metrics-js';
// @ts-expect-error dependency missing types
import UpgradeProductToApiNameMap from 'self-service-api/constants/UpgradeProductToApiNameMap';
export const PPUIMetrics = createMetricsFactory('pricing-pages-ui');
export const UIAUMetrics = createMetricsFactory('ui-addon-upgrades', {
  library: 'ui-addon-upgrades'
});
export const trackTalkToSalesPql = app => {
  if (app === 'pricing-pages') {
    // For namespace-specific alerting monitorable by the pricing-pages team
    PPUIMetrics.counter('talk-to-sales-pql').increment();
  }
  UIAUMetrics.counter('talk-to-sales-pql', {
    app
  }).increment();
};
export const trackPqlFailure = app => {
  UIAUMetrics.counter('pql-failure', {
    app
  }).increment();
};
export const trackFailedApiNameMap = (location, apiName, upgradeProduct) => {
  if (location) {
    UIAUMetrics.counter('failed-api-name-map', {
      location,
      apiName,
      upgradeProduct: upgradeProduct || ''
    }).increment();
  }
};
export const trackTrialActivation = (app, upgradeProduct, apiName) => {
  const mappedApiName = upgradeProduct && UpgradeProductToApiNameMap[upgradeProduct];
  UIAUMetrics.counter('trial-activation', {
    app,
    upgradeProduct: upgradeProduct || '',
    apiName: apiName || mappedApiName
  }).increment();
};
export const trackPurchaseMotionFailure = ({
  uniqueId,
  apiName,
  purchaseMotion
}) => {
  UIAUMetrics.counter('purchase-motion-failure', {
    uniqueId,
    apiName,
    purchaseMotion
  }).increment();
};
export const trackUpgradePointTooltipFailure = upgradeKey => {
  UIAUMetrics.counter('locked-feature-tooltip-failure', {
    upgradeKey
  }).increment();
};
export const trackUpgradeBannerFailure = upgradeKey => {
  UIAUMetrics.counter('upgrade-banner-failure', {
    upgradeKey
  }).increment();
};